import * as actions from './rfr-ord-save.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { loadingRfrOrdSave } from 'src/app/shared/_config/i18n/i18n-interface';
import { rfrOrdSearchActions } from '../rfr-ord-search';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class RfrOrdSaveEffects {
  private readonly actions$ = inject(Actions);
  private readonly sharedGenericService = inject(SharedGenericService);


  load$ = createEffect(() =>
    this.actions$.pipe(ofType(actions.load),
      mergeMap((params) => this.sharedGenericService.invoke(ApiRfrMethod.rfrOrdSave, params.query).pipe(
        map((data) => actions.received({ data })),
        catchError((error: SharedErrorObjectI) => [actions.error({ messageText: error.message })])
      ))
    ));

  onError$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.error),
    mergeMap((action: { messageText: string }) => {
      return [
        spxToasterActions.createError({
          autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
          messageText: action.messageText,
        })
      ]
    })
  ));

  afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.load),
    mergeMap(() => [
      spxSpinnerActions.show({
        action: loadingRfrOrdSave
      }),
    ]))
  );

  afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.error),
    mergeMap(() => [
      spxToasterActions.createError({
        messageText: `Not processed`,
        autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
      }),
      spxSpinnerActions.hide({
        action: loadingRfrOrdSave
      }),
    ]))
  );

  afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.received),
    mergeMap(() => [
      spxToasterActions.createSuccess({
        messageText: `Processed`,
        autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
      }),
      spxSpinnerActions.hide({
        action: loadingRfrOrdSave
      }),
      rfrOrdSearchActions.load({
        query: {}
      }),
    ]))
  );
}
